import * as React from "react";
import { useFormContext } from "react-hook-form";
import { IInputFieldProps, FieldSchema, FormControlDependsOnThenEnum } from "@generation/core";
import { useDependsOnHook } from "./useDependsOnHook";
import { useFormPropsContext } from "../Context/FormPropsContextProvider";

export function withHideOnFieldHoc<T extends IInputFieldProps<FieldSchema>>(
  Component: React.FunctionComponent<T>
) {
  const component = (props: T) => {
    const { unregister } = useFormContext();
    const formProps = useFormPropsContext();

    if ((props.field.ui?.formOverview?.render ?? true) === false) {
      if (props.field.ui?.formOverview?.renderFormGroupWhenHidden === true) {
        return <div className="form-group" />;
      }

      return <></>;
    }

    const formFieldName = props.name.substring(0, props.name.lastIndexOf(".")) ?? "";

    const result = useDependsOnHook(formFieldName, props.field.dependsOn, [
      FormControlDependsOnThenEnum.Hide
    ]);

    React.useEffect(() => {
      if (result.hide) {
        unregister(props.name, {
          keepError: false,
          keepValue: formProps?.dependsOn?.keepValues ?? false,
          keepDefaultValue: formProps?.dependsOn?.keepDefaultValues ?? false
        });
      }
    }, [result.hide]);

    if (result.hide) {
      if (props.field.ui?.formOverview?.renderFormGroupWhenHidden === true) {
        return <div className="form-group" />;
      }
      return <></>;
    }

    return <Component {...props} />;
  };

  component.displayName = "WithHideOnFieldHoc";

  return component;
}
